import React, { useState, useEffect } from 'react';
import { NextSeo } from 'next-seo';
import 'intersection-observer';
import scrollama from 'scrollama';
import Layout from '~/components/Layouts/LayoutBasic/LayoutBasic';
// import Breadcrumb from '~/components/BreadcrumbNav/BreadcrumbNav';
import scrollAnimation from '~/utils/scroll-animation';

import css from '~/styles/join/join.less';

const JoinUs = () => {
  const [step, setStep] = useState(0);
  const [data] = useState([
    // {
    //   title: '交易运营',
    //   duty: [
    //     '帮助微信社群的精准线索完成消费决策，并在平台下单；',
    //     '跟进客户服务流程，保证服务满意度，并促成二次消费；',
    //     '维护专属客户群，在群内完成咨询、维护和消费引导；',
    //     '不断打磨客户销售流程和话术，持续提升成交转化率。',
    //   ],
    //   requirements: [
    //     '熟悉微信生态及社群，有较强的沟通能力和群转化交易能力；',
    //     '聪明（职位上有的信息不再重复问）上进（有强烈的成就动机）正直坦诚；',
    //     '对销售类工作充满热情，能为交易毛利、转化率和活动招募负责；',
    //     '有K12社群运营经验或了解母婴行业者或宝妈优先。',
    //   ],
    // },
    {
      title: '母婴顾问',
      duty: [
        '负责用户咨询，为用户挑选合适的月嫂/月子会所，介绍服务，促成签单，完成月度、季度销售指标；',
        '深入了解熟悉公司产品，合理利用公司分配的资源，向客户介绍产品，匹配服务需求，促成签约；',
        '及时跟进未签约客户，了解原因及意向，精准匹配需求，促成签约；',
        '建立客户关系群，为客户提供更高质的服务。',
      ],
      requirements: [
        '热爱工作，能深入掌握产品卖点，了解客户需求，高效匹配；',
        '具有较高的服务意识、良好的组织协调能力、分析和解决问题的能力；',
        '有团队精神，热爱平台；',
        '具有服务意识、责任心、热情、礼貌、有亲和力、能吃苦耐劳。',
      ],
    },
    {
      title: '社群运营',
      duty: [
        '通过微信助理号运营同一阶段的孕产用户，负责进行朋友圈、微信群运营；',
        '打造个性鲜明的群主形象，不断强化群主人设，增强信任感；',
        '组织各类朋友圈和群内的互动活动，增强社群活跃度，引导用户产生有价值的UGC；',
        '基于用户需求，组织和执行团购活动，培养用户在社群内的消费习惯。',
      ],
      requirements: [
        '通过微信助理号运营同一阶段的孕产用户，负责进行朋友圈、微信群运营； ',
        '打造个性鲜明的群主形象，不断强化群主人设，增强信任感；',
        '组织各类朋友圈和群内的互动活动，增强社群活跃度，引导用户产生有价值的UGC；',
        '基于用户需求，组织和执行团购活动，培养用户在社群内的消费习惯。',
      ],
    },
    // {
    //   title: '运营实习生',
    //   duty: [
    //     '负责用户社群的运营和管理，对用户的问题进行答疑和反馈；',
    //     '组织各类朋友圈和群内的互动活动，增强社群活跃度；',
    //     '总结运营经验，不断优化运营流程；',
    //     '基于用户需求，组织和执行团购活动，培养用户在社群内的消费习惯。',
    //   ],
    //   requirements: [
    //     '本科及以上学历；',
    //     '良好的沟通表达能力，较强的同理心，能和用户建立良好的关系；',
    //     '较强的学习能力和应变能力，能够适应公司快速的发展节奏；',
    //     '较强的目标感和团队意识，对工作结果负责。',
    //   ],
    // },
  ]);

  const switchTab = id => {
    const tabElement = document.getElementById(id);
    if (id && tabElement) {
      const targetY = tabElement.offsetTop + 45 || 0;
      scrollAnimation(targetY);
    }
  };

  useEffect(() => {
    const scroller = scrollama();
    scroller
      .setup({
        step: '.step',
      })
      .onStepEnter(resp => {
        setStep(resp.index || 0);
      });
  }, []);

  return (
    <Layout>
      <NextSeo
        title="加入我们 - 新得宝贝"
        description="母婴服务放心选"
        additionalMetaTags={[
          {
            name: 'keywords',
            content: '新得宝贝,MUA孕育守护',
          },
        ]}
      />
      {/* <Breadcrumb title="加入我们" /> */}
      <div className={css.main}>
        {/* 左侧tab */}
        <div className={css.sticky}>
          <div className={css.left}>
            <p className={css.pageTitle}>加入我们</p>
            <ul className={css.tabList}>
              {data.map((item, index) => {
                return (
                  <li
                    key={index.toString()}
                    className={`${css.tab} ${step === index ? css.active : ''}`}
                    onClick={() => switchTab(`tab${index}`)}
                  >
                    {item.title}
                  </li>
                );
              })}
            </ul>
            <p className={css.email}>
              发送简历至：
              <br />
              career@xindebaby.com{' '}
            </p>
          </div>
        </div>
        {/* 右侧岗位介绍 */}
        <div>
          {data.map((item, index) => {
            return (
              <div
                className={`step ${css.item}`}
                key={index.toString()}
                id={`tab${index}`}
              >
                <p className={css.title}>{item.title}</p>

                <p className={css.secTitle}>岗位职责</p>
                <ol className={css.box}>
                  {item.duty.map((items, indexs) => {
                    return (
                      <li className={css.msg} key={indexs.toString()}>
                        {indexs + 1}、{items}
                      </li>
                    );
                  })}
                </ol>

                <p className={css.secTitle}>任职要求</p>
                <ol className={css.box}>
                  {item.requirements.map((items, indexs) => {
                    return (
                      <li className={css.msg} key={indexs.toString()}>
                        {indexs + 1}、{items}
                      </li>
                    );
                  })}
                </ol>
              </div>
            );
          })}
        </div>
      </div>
      <div className={css.bottom}> </div>
    </Layout>
  );
};

JoinUs.getInitialProps = async ({ pathname, query, dvaStore }) => {
  // dispatch effects to fetch data here
  return {
    pathname,
    query,
    dvaStore,
  };
};

export default JoinUs;
